import type { SVGProps } from 'react';

const SvgUserGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18.17 8.92c.41-.61.64-1.34.64-2.11C18.81 4.71 17.1 3 15 3c-1.02 0-1.98.4-2.7 1.12a.996.996 0 1 0 1.41 1.41 1.809 1.809 0 0 1 3.09 1.28c0 .64-.33 1.22-.87 1.55-.04.02-.06.06-.09.08-.06.05-.13.1-.18.17-.04.05-.06.11-.09.17-.03.05-.06.09-.08.15v.03c-.02.06-.01.13-.02.2 0 .06-.02.13 0 .19 0 .05.03.1.05.15.02.07.04.15.08.22v.03c.05.09.12.16.2.23.02.01.03.02.05.04.09.07.18.12.29.15A3.98 3.98 0 0 1 19 14.01c0 .55.45 1 1 1s1-.45 1-1c0-2.12-1.1-4-2.83-5.08zm-4.66 5.04c.54-.73.87-1.62.87-2.59 0-2.41-1.96-4.38-4.38-4.38s-4.38 1.96-4.38 4.38c0 .97.33 1.86.87 2.59A6.95 6.95 0 0 0 3 20c0 .55.45 1 1 1s1-.45 1-1c0-2.09 1.28-3.91 3.2-4.65.55.25 1.16.4 1.8.4s1.25-.15 1.8-.4c1.92.74 3.2 2.56 3.2 4.65 0 .55.45 1 1 1s1-.45 1-1c0-2.55-1.36-4.81-3.49-6.04m-5.89-2.58C7.62 10.07 8.69 9 10 9s2.38 1.07 2.38 2.38-1.07 2.38-2.38 2.38-2.38-1.07-2.38-2.38"
    />
  </svg>
);
export default SvgUserGroup;
